<template>
  <b-modal size="lg" ref="add-sub-category" id="add-sub-category" hide-footer hide-header centered>
    <h2 class="text-center mb-4">Alkategória létrehozása</h2>
    <form @submit="handleSubmit">
      <div role="group" class="input-wrapper mt-4">
        <label for="title">Alkategória neve</label>
        <b-form-input
          id="title"
          v-model="title"
          :state="titleState"
          aria-describedby="title-live-feedback"
          placeholder="Adja meg az alkategória nevét"
          trim
        ></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
          Legalább 5 karakter hosszú
        </b-form-invalid-feedback>
      </div>

      <b-row class="px-3 pb-4 d-flex justify-content-center mt-4">
        <b-button class="mr-2 mb-2" @click="() => this.$bvModal.hide('add-sub-category')">Vissza</b-button>
        <b-button :disabled="!titleState" variant="primary" type="submit" class="mb-2">Alkategória mentése</b-button>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import { createSubCategory } from '../../../../api/fundMapCategories'
export default {
  computed: {
    titleState() {
      if (!this.titleTouched) return null
      return this.title.length > 4 ? true : false
    }
  },
  data() {
    return {
      title: '',
      titleTouched: false
    }
  },
  watch: {
    title() {
      this.titleTouched = true
    }
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault()
      try {
        const newSubCategory = await createSubCategory({
          title: this.title
        })
        this.$emit('added-sub-category', newSubCategory)
        this.$bvModal.hide('add-sub-category')
      } catch (e) {
        console.log('Creating sub category error')
      }
    }
  }
}
</script>

<style scoped>
.input-wrapper {
  padding-inline: 0;
  max-width: 500px;
  margin: 0 auto;
}
.input-wrapper > * {
  text-align: left !important;
  font-size: 16px;
}
.input-wrapper label {
  width: 100%;
  padding: 0;
  color: #000;
  font-weight: 700;
  font-size: 12px;
}
</style>
